/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Inspector_TitleInputs */

const cs_builder_inspector_title = /** @type {(inputs: Builder_Inspector_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blok`)
};

const en_builder_inspector_title = /** @type {(inputs: Builder_Inspector_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block`)
};

/**
* | output |
* | --- |
* | "Block" |
*
* @param {Builder_Inspector_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_inspector_title = /** @type {((inputs?: Builder_Inspector_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Inspector_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_inspector_title(inputs)
	return cs_builder_inspector_title(inputs)
});